import {html, css, LitElement} from 'lit';
import { StorageMixin } from "../storage-mixin.js"


export class DzCompareButton extends StorageMixin(LitElement) {
 
    static get properties() {
        return {
            key:      { type: String },
            dataset:  { type: String },
            items:    { type: String, store: true }
        }
    }

    render() {  
        if (this.isPresent()) {
            return html`<slot name="present" @click="${() => window.location.href = "/catalog/compare/" }"></slot><div></div>`
        } else {
            return html`<slot name="default" @click="${this.addToList}"></slot><div></div>`
        }
    }

    isPresent() {
        if (this.items.filter((item) =>item.key == this.key).length > 0) {
            return true
        }
        return false
    }

    addToList() {
        if (this.isPresent()) {
            BX.UI.Notification.Center.notify({
                content: "Такой элемент уже в списке !",
                position: "top-right",
                autoHideDelay: 2000,
            });
        } else {
            let list = this.items
            list.unshift(JSON.parse(this.dataset))
            this.items = list
        }
    }
}

customElements.define('dz-compare-button', DzCompareButton)